import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';

import { Pagination } from 'components';

import { ACTIVITIES } from 'graphql/queries/activities';

import {
  Typography,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Button
} from '@material-ui/core';

import useStyles from './styles';

const headingsConfig = classes => {
  return [
    { label: 'Photo', align: 'left', cellClassName: classes.imgCell },
    {
      label: 'Activity',
      cellClassName: classes.nameCell,
      align: 'left'
    },
    {
      label: 'Min/Max number of participants',
      cellClassName: classes.participantsCell,
      align: 'left'
    },
    {
      label: 'Activity type',
      cellClassName: classes.activityTypeCell,
      align: 'left'
    },
    {
      label: 'Product code',
      cellClassName: classes.productCodeCell,
      align: 'left'
    },
    {
      label: 'Starting point',
      cellClassName: classes.startingPointCell,
      align: 'left'
    },
    { label: '', align: 'right' }
  ];
};

function ActivitiesList({ businessOwner }) {
  const classes = useStyles();
  const history = useHistory();
  const [t] = useTranslation();

  const [page, setPage] = React.useState(0);

  const { data, refetch } = useQuery(ACTIVITIES, {
    variables: {
      page: page,
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });

  React.useEffect(() => {
    refetch();
  }, []);

  const onPageChangeHandler = (e, page) => {
    refetch({
      page: page - 1
    });
    setPage(page - 1);
  };

  return (
    <TableContainer component="div" classes={{ root: classes.container }}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            {headingsConfig(classes).map(heading => (
              <TableCell
                key={heading.label}
                align={heading.align}
                className={classNames(
                  classes.tableCell,
                  classes.headTableCell,
                  heading.cellClassName
                )}
              >
                <Typography variant="h3" className={classes.heading}>
                  {t(heading.label)}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.activities &&
            data.activities.map(activity => (
              <TableRow
                key={activity.id}
                classes={{ root: classes.tableRow }}
                onClick={() => history.push(`/activities/${activity.id}/book`)}
              >
                <TableCell
                  className={classNames(classes.tableCell, classes.imgCell)}
                  component="th"
                  scope="row"
                >
                  <div className={classes.imageWrapper}>
                    {activity.photo && (
                      <img
                        src={activity.photo}
                        alt=""
                        className={classes.image}
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell
                  className={classNames(classes.tableCell, classes.nameCell)}
                  align="left"
                >
                  {activity.title}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.participantsCell
                  )}
                  align="left"
                >
                  {activity.minParticipants}/{activity.maxParticipants}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.activityTypeCell
                  )}
                  align="left"
                >
                  {activity.isOpen ? t('Open') : t('Private')}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.productCodeCell
                  )}
                  align="left"
                >
                  {activity.productCode}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.startingPointCell
                  )}
                  align="left"
                >
                  {activity.startingPoint}
                </TableCell>
                {/* <TableCell className={classes.tableCell} align="right">
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      history.push(`/activities/${activity.id}/manual-book`);
                    }}
                    variant="outlined"
                    color="primary"
                    classes={{ root: classes.buttonRoot }}
                  >
                    {t('Manual book')}
                  </Button>
                </TableCell> */}
                <TableCell className={classes.tableCell} align="left">
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      history.push(`/activities/${activity.id}/book`);
                    }}
                    variant="outlined"
                    color="primary"
                    classes={{ root: classes.buttonRoot }}
                  >
                    {t('Book')}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      {data && (
        <Pagination
          page={page + 1}
          count={data.numberOfActivitiesPages}
          onChange={onPageChangeHandler}
          amount={data.activities.length}
          total={data.accommodationsActivitiesOverview.activities.total}
        />
      )}
    </TableContainer>
  );
}

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(ActivitiesList);
